import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: { 
    reward_counts: [],
    impression_counts: [],
    graph_counts: [],
    endpoints: {
      rewardCounts: 'https://stormy-mountain-29119.herokuapp.com/v3/reward_counts/',
      impressionCounts: 'https://stormy-mountain-29119.herokuapp.com/v3/impression_counts/',
      graphCounts: 'https://stormy-mountain-29119.herokuapp.com/v3/graph_counts/',
    }
  },
  mutations,
  actions,
  getters,
}